var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLikeSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16.5 4a4.72 4.72 0 0 0-2.839.926c-.807.59-1.344 1.34-1.66 1.886-.317-.546-.854-1.296-1.662-1.886A4.72 4.72 0 0 0 7.5 4C4.593 4 2.4 6.245 2.4 9.222c0 3.216 2.736 5.416 6.877 8.747.703.566 1.5 1.207 2.328 1.891.11.09.25.14.395.14a.62.62 0 0 0 .395-.14 234 234 0 0 1 2.33-1.891c4.14-3.33 6.875-5.531 6.875-8.747C21.6 6.245 19.408 4 16.5 4"
})));
export default SvgLikeSmall;